module.exports = fox._r("images/logos/converge.png", __webpack_public_path__ + "_/_/_/common/frame/images/logos/converge.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/logos/converge.png
// module id = 318
// module chunks = 2